import { createSectionColumnId } from '../../../utils/proposalSectionColumns';
import { normalizeImageFocalPoint } from '../../../media/imageFocalPoint';

export const pointPosition = (point) => normalizeImageFocalPoint(point) || { x: 50, y: 50 };

// Les nouveaux repères s'écartent du centre pour ne pas s'empiler.
const STAGGER = [[0, 0], [20, -12], [-20, 12], [20, 12], [-20, -12]];
const staggered = (index) => ({ x: 50 + STAGGER[index % STAGGER.length][0], y: 50 + STAGGER[index % STAGGER.length][1] });

export const createHotspot = (index = 0, position) => ({ id: createSectionColumnId(), title: '', description: '', ...(position ? pointPosition(position) : staggered(index)) });

export function uniqueHotspots(points) {
  const seen = new Set();
  return points.map((point) => {
    const id = point.id && !seen.has(point.id) ? point.id : createSectionColumnId();
    seen.add(id);
    return id === point.id ? point : { ...point, id };
  });
}


const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
export const MIN_RECTANGLE_SIZE = 5;
const dimension = (value, fallback) => clamp(Number.isFinite(Number(value)) ? Number(value) : fallback, MIN_RECTANGLE_SIZE, 100);
export const hotspotNumberSide = (point) => ['left', 'right', 'top', 'bottom'].includes(point.numberSide) ? point.numberSide : 'right';

export function hotspotGeometry(point) {
  const position = pointPosition(point);
  if (point.shape !== 'rectangle') return position;
  const width = dimension(point.width, 25);
  const height = dimension(point.height, 20);
  return {
    shape: 'rectangle', width, height,
    x: clamp(position.x, width / 2, 100 - width / 2),
    y: clamp(position.y, height / 2, 100 - height / 2),
  };
}

export function moveHotspotRectangle(point, delta) {
  const geometry = hotspotGeometry(point);
  return hotspotGeometry({ ...geometry, x: geometry.x + delta.x, y: geometry.y + delta.y });
}

export function resizeHotspotRectangle(point, side, delta) {
  const { x, y, width, height } = hotspotGeometry(point);
  let left = x - width / 2;
  let right = x + width / 2;
  let top = y - height / 2;
  let bottom = y + height / 2;
  if (side.includes('left')) left = clamp(left + delta.x, 0, right - MIN_RECTANGLE_SIZE);
  if (side.includes('right')) right = clamp(right + delta.x, left + MIN_RECTANGLE_SIZE, 100);
  if (side.includes('top')) top = clamp(top + delta.y, 0, bottom - MIN_RECTANGLE_SIZE);
  if (side.includes('bottom')) bottom = clamp(bottom + delta.y, top + MIN_RECTANGLE_SIZE, 100);
  return { shape: 'rectangle', x: (left + right) / 2, y: (top + bottom) / 2, width: right - left, height: bottom - top };
}

export function hotspotMarkerStyle(point) {
  const geometry = hotspotGeometry(point);
  return {
    left: `${geometry.x}%`, top: `${geometry.y}%`,
    ...(point.shape === 'rectangle' ? { width: `${geometry.width}%`, height: `${geometry.height}%` } : {}),
  };
}
